import React from "react";

import ContentCore from "../../../../core/workingContent";

import "../../_index.css";

const TaskDelayReceiverUI = () => {
  return (
    <>
      <ContentCore />
    </>
  )
}

export default TaskDelayReceiverUI;
